var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
      _vm.test.testType === 'HEURISTICS' ||
        (_vm.test.testType === 'User' && _vm.test.userTestType === 'unmoderated')
    )?_c('div',[_c('UnmoderatedCoopsView')],1):_vm._e(),(_vm.test.testType === 'User' && _vm.test.userTestType === 'moderated')?_c('div',[_c('ModeratedCoopsView')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }